//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import M_TBG_CUSTOM from './M_TBG_CUSTOM';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import Commons from '../../../../Services/Common/Common';
import { useSearch1, useSearch2, useSave1 } from './M_TBG_CUSTOM_Query';
import { useSave } from '../../../../Hooks/useSave';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
//#endregion

function M_TBG_CUSTOMF() {
  //#region 변수
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    type: 'info',
  });
  const [messages, setMessages] = useState([]);
  const [userCount, setUserCount] = useState(0);
  const [addMeetingFlag, setAddMeetingFlag] = useState(false);
  const [check, setCheck] = useState([]);
  const ws = useRef(null);
  const tbmCdRef = useRef(null);
  const startTimeRef = useRef(null);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  //#endregion
  const activeStepRef = useRef(activeStep);
  useEffect(() => {
    activeStepRef.current = activeStep;
  }, [activeStep]);

  // 스택형 뒤로가기로 변경: 0단계(첫 진입)에서는 이탈 확인 바텀시트
  useBackStack({
    type: 'sheet',
    enabled: activeStep === 0 && !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickTbm' })),
  });

  // 스택형 뒤로가기로 변경: 1단계 이상부터는 이전 단계로 복귀
  useBackStack({
    type: 'step',
    enabled: activeStep > 0 && activeStep < 9,
    onBack: () => {
      // 이전 단계로 이동 (작업허가서와 동일한 로직)
      dispatch(CommonActions.setActiveStep(activeStepRef.current - 1));
    },
  });
  //#region 이벤트
  useEffect(() => {
    Init();
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('TBM'));
    dispatch(NavBarInfoActions.setBgColor('#F3F7F8'));

    let listener;
    if (Capacitor.isNativePlatform()) {
      listener = App.addListener('appStateChange', async (state) => {
        if (state.isActive) {
          if (!ws.current || ws.current.readyState !== WebSocket.OPEN) {
            try {
              if (ws.current) ws.current.close();
              await OpenWebSocket();
            } catch (error) {
              setSnackbar((prev) => ({
                ...prev,
                open: true,
                message:
                  '연결을 복구할 수 없습니다. 페이지를 새로고침해주세요.',
                type: 'error',
              }));
            }
          } else {
            Search2Async({ tbmCd: tbmCdRef.current });
          }
        }
      });
    }

    return () => {
      if (ws.current) ws.current.close();
      if (listener) listener.remove();
    };
  }, []);

  const Init = async () => {
    try {
      await Search1Async();
    } catch (e) {
      setSnackbar({
        ...snackbar,
        open: true,
        message: e.message,
        type: 'error',
      });
    }
  };
  //#endregion

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      tbmCdRef.current = rows[0].tbmCd;
      OpenWebSocket();
    },
  });
  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      if (rows.length > 0) {
        tbmCdRef.current = rows[0].tbmCd;
        startTimeRef.current = new Date(rows[0].tbmStartDate);

        // status 조회 성공 시 해당 단계로 이동(진행중인 tbm이 있는 경우)
        dispatch(CommonActions.setActiveStep(rows[0].mStep));
      } else {
        // status 조회 실패 시 초기화(진행중인 tbm이 없는 경우)
        Save1([{ eStep: 0, mStep: 0, tbmCd: tbmCdRef.current }]);
        dispatch(CommonActions.setActiveStep(0));
      }
    },
  });
  const { runAsync: Save1Async } = useSave1();

  // 저장
  const { run: Save1 } = useSave({
    menuId: 'M_TBG_CUSTOM',
    requestSave: (rows) => Save1Async(rows),
  });
  //#endregion

  //#region 나머지함수
  const OpenWebSocket = async () => {
    ws.current = new WebSocket(
      `${process.env.REACT_APP_WEB_SOCKET}?roomId=${
        tbmCdRef.current
      }&userId=${Commons.DecryptoAES(userInfo.userid)}`
    );

    ws.current.onopen = () => {
      console.log('웹소켓 연결됨');
      Search2Async({ tbmCd: tbmCdRef.current });
    };

    ws.current.onmessage = (event) => {
      const HandleText = (text) => {
        try {
          const data = JSON.parse(text);
          if (data.type === 'userCount') {
            // tbm 총 인원수
            setUserCount(data.count);
          } else if (data.type === 'roomState') {
            // 접속 시 서버가 보낸 방 상태 (교육 완료 인원 정보)
            setCheck(data.check);
          } else if (data.type === 'message') {
            setMessages((prev) => [...prev, data.content]);
          } else if (data.type.includes('check')) {
            // 교육여부 체크
            setCheck((prev) => {
              if (
                !prev.some(
                  (item) => item.id === data.id && item.type === data.type
                )
              ) {
                return [...prev, data];
              }
              return prev;
            });
          }
        } catch (e) {
          setMessages((prev) => [...prev, text]);
        }
      };

      if (event.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => HandleText(reader.result);
        reader.readAsText(event.data);
      } else {
        HandleText(event.data);
      }
    };

    ws.current.onerror = (error) => {
      console.error('WebSocket 오류:', error);
    };

    ws.current.onclose = () => {
      console.log('웹소켓 연결 종료됨');
    };
  };

  const SendMessage = (title) => {
    if (ws.current && title.trim() !== '') {
      ws.current.send(title);
    }
  };

  const ActiveButton = (data) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(data));
    } else {
      setSnackbar({
        open: true,
        message: '웹소켓 연결 중입니다. 잠시 후 다시 시도해 주세요.',
        type: 'warning',
      });
    }
  };

  const TbmEnd = () => {
    dispatch(CommonActions.setActiveStep(0));
    if (ws.current) ws.current.close();
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TBG_CUSTOM
        activeStep={activeStep}
        userInfo={userInfo}
        lanList={lanInfo}
        userCount={userCount}
        setUserCount={setUserCount}
        check={check}
        setCheck={setCheck}
        addMeetingFlag={addMeetingFlag}
        setAddMeetingFlag={setAddMeetingFlag}
        tbmCdRef={tbmCdRef}
        startTimeRef={startTimeRef}
        ActiveButton={ActiveButton}
        SendMessage={SendMessage}
        TbmEnd={TbmEnd}
      />
    </div>
  );
}

export default M_TBG_CUSTOMF;
